import { PropsWithChildren, Suspense } from 'react';
import GlobalLoading from '@/global-loading.tsx';

function LazyLoading({ children }: PropsWithChildren) {
  return <Suspense fallback={<GlobalLoading />}>{children}</Suspense>;
}

export default LazyLoading;
